import { cn } from '@/lib/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-neutrals-N300 dark:bg-neutrals-N800',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
